// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xmMS","icon":"styles_icon__HrRBw"};